import React, {useEffect} from "react";
import ParticlesBg from "particles-bg";
import Fade from "react-reveal";
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";

const Header = () => {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (location) {
      const currentPath = location.pathname;
      const formattedPath = currentPath.replace('/', '#');
      window.location.href = formattedPath;
    }
  }, []);
  

  return (
    <header id="home">
      <ParticlesBg type="square" bg={true} />

      <nav id="nav-wrap">
        <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
          Show navigation
        </a>
        <a className="mobile-btn" href="#home" title="Hide navigation">
          Hide navigation
        </a>

        <ul id="nav" className="nav">
          <li className="current">
            <a className="smoothscroll" href="#home">
              Home
            </a>
          </li>

          <li>
            <a className="smoothscroll" href="#about">
              {t('navigation.info')}
            </a>
          </li>

          <li>
            <a className="smoothscroll" href="#resume">
            {t('navigation.howToPlay')}
            </a>
          </li>

          <li>
            <a className="smoothscroll" href="#portfolio">
            {t('navigation.screenshots')}
            </a>
          </li>

          <li>
            <a className="smoothscroll" href="#terms">
            {t('navigation.termsAndConditions')}
            </a>
          </li>

          <li>
            <a className="smoothscroll" href="#privacy">
            {t('navigation.privacyPolicy')}
            </a>
          </li>
        </ul>
      </nav>

      <div className="row banner">
        <div className="banner-text">
          <Fade bottom>
            <img className="logo" src="images/challenz_logo_noBg.gif" alt="Nordic Giant Profile Pic" />
          </Fade>
          <Fade bottom duration={1200}>
            {/* <h3>{description}.</h3> */}
          </Fade>
          <hr />
          <Fade bottom duration={2000}>
          <a href='https://play.google.com/store/apps/details?id=com.challenzthegame'>
            <img className="googlePlayButton" alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
            </a>
          </Fade>
        </div>
      </div>

      <p className="scrolldown">
        <a className="smoothscroll" href="#about">
          <i className="icon-down-circle"></i>
        </a>
      </p>
    </header>
  );
};

export default Header;
